import { Helmet } from 'react-helmet'

function PrivatumaPolitika() {
  // Check localStorage for the 'lang' key
  const lang = localStorage.getItem('lang');

  // --- English Version ---
  // If lang is 'en', display the English translation
  if (lang === 'en') {
    return (
      <div className="noteikumi privatuma">
        <Helmet>
          <title>Nora Spora - Privacy Policy</title>
          <meta name="description" content="Explore our privacy policy to learn how we protect your personal data and ensure its security." />
          <meta name="keywords" content="privacy policy, data protection, personal data, NORA SPORA" />
          <meta name="robots" content="index, follow" />
        </Helmet>
          <h2 className="light">Privacy Policy</h2>
          <ol>
              <li>GENERAL TERMS
                  <p>
                  This &quot;Privacy Policy&quot; (hereinafter &quot;Policy&quot;) applies to all users of SIA &quot;NORA SPORA&quot;
                  (hereinafter &quot;We&quot;, &quot;Us&quot;) website (hereinafter &quot;Website&quot;) (hereinafter &quot;You&quot;, &quot;Your&quot;).
                  Please read the Policy carefully before placing an order. Over time, we may make
                  changes to the Policy, so please review it before making subsequent purchases.
                  <br /><br />
                  According to general data protection regulations, personal data is any information that can be
                  used to identify a person, as well as any information about a person who has already been
                  identified. By using our website services, you provide us with your personal data and the right to
                  process and use it in accordance with the terms set out in this Privacy Policy and the &quot;Terms of
                  Use&quot; (hereinafter &quot;Terms&quot;).
                  <br /><br />
                  We are committed to protecting the privacy and security of our customers and website visitors,
                  including you. By using our website services, you place your trust in us. We fully appreciate this
                  and respect the importance of your data privacy and confidentiality.
                  <br /><br />
                  We adhere to the principle of data minimization – we do not request, collect, or process personal
                  data that is not necessary to achieve the purpose – purchasing goods, services, or receiving
                  information.
                  <br /><br />
                  We respect your privacy and do everything possible to keep your personal data secure.
                  We do not allow unsolicited emails and under no circumstances will we sell, rent, or transfer any
                  of your personal data (name, address, email, etc.) to third parties. Information may only be
                  disclosed to third parties based on a legal request, contract, or with your consent.
                  <br /><br />
                  You are responsible for the accuracy of the information when placing an order or contacting
                  customer support. You confirm that you are not under 16 years old and agree not to perform any
                  actions that threaten the security of the Website. We are not responsible for incorrect, incomplete,
                  or erroneous information you provide.
                  <br /><br />
                  By using our website and/or purchasing goods and/or services, you confirm that you understand
                  the Policy and agree to follow any updates.
                  <br /><br />
                  If you do not agree with this Policy or any part of it, please do not use our website services.
                  </p>
              </li>

              <li>WHAT DATA WE COLLECT AND PROCESS
                <p>
                  When placing an order or contacting customer support, you provide us with your
                  personal information. Providing personal data is mandatory for purchases, as you cannot
                  complete a purchase without it.
                  <br /><br />
                  We collect and store the following data:
                </p>
                <ul className="" style={{listStyle: "disc", paddingLeft: "20px", fontWeight: "400"}}>
                  <li>Customer&#39;s full name;</li>
                  <li>Phone number;</li>
                  <li>Email address;</li>
                  <li>Delivery address for goods or services.</li>
                </ul>
                <p>
                  <br />
                  Private information is only used to provide full services and communicate with customers.
                  <br /><br />
                  We may only receive your personal information from you and only if you use our website
                  services, such as placing orders, contacting customer support through feedback forms, or via
                  email.
                </p>
              </li>

              <li>PAYMENT INFORMATION
              <p>Payment processing is provided by the payment platform <a href="https://makecommerce.lv">makecommerce.lv</a>, therefore our company transfers the personal data necessary for payment execution to the platform owner Maksekeskus AS.</p>
            <p>
              When paying for goods and services provided by SIA &quot;NORA SPORA&quot; website, we may
              collect and process the following information:
            </p>
            <ul style={{listStyle: "disc", paddingLeft: "20px", fontWeight: "400"}}>
              <li>Your bank account number;</li>
              <li>Name of the bank;</li>
              <li>Your phone number;</li>
              <li>Email address.</li>
            </ul>
            <p>
              We do not receive or process your bank card information.
            </p>
          </li>

          <li>WHY WE COLLECT YOUR DATA
            <p>
              We use the information we collect about you to:
            </p>
            <ul style={{listStyle: "disc", paddingLeft: "20px", fontWeight: "400"}}>
              <li>Sell our goods and services;</li>
              <li>Correctly process and deliver your order;</li>
              <li>Provide warranty and post-warranty support;</li>
              <li>Respond to your inquiries and provide information;</li>
              <li>Prepare anonymous statistics on website usage.</li>
            </ul>
          </li>

          <li>HOW LONG WE STORE YOUR DATA
            <p>
              Customer personal information is stored for 10 years:
            </p>
            <ul style={{listStyle: "disc", paddingLeft: "20px", fontWeight: "400"}}>
              <li>To provide warranty and post-warranty support for purchased products;</li>
              <li>To communicate with you regarding requests;</li>
              <li>For accounting purposes.</li>
            </ul>
            <p>
              After 10 years, personal data will be destroyed unless you request the deletion of your
              data during this period.
            </p>
          </li>

          <li>DATA SHARING WITH THIRD PARTIES
            <p>
              Your data may be shared with third parties, such as data centers, support services,
              delivery services, cloud storage representatives, etc. Personal data processors assist us in
              providing services to you. In any case, processors only receive the necessary amount of
              data required to perform a specific task or service. Associated third parties may process
              your personal data only for the specified purposes and cannot use it for other purposes or
              transfer it to others without our consent. Processors ensure the protection of your
              personal data in accordance with applicable laws.
            </p>
            <p>
              Personal data may be disclosed to competent government authorities, including law
              enforcement, but only when necessary and in accordance with the legal procedures
              established by law.
            </p>
          </li>

          <li>TRANSFER OF DATA TO THIRD COUNTRIES
            <p>
              SIA &quot;NORA SPORA&quot; does not transfer personal information or other data to third
              countries. Personal and other user data is only disclosed based on a lawful request.
            </p>
          </li>

          <li>USER RIGHTS
            <p>
              Data protection laws, including the General Data Protection Regulation (GDPR), give
              you certain rights, and we must ensure that you can exercise them:
            </p>
            <ul style={{listStyle: "disc", paddingLeft: "20px", fontWeight: "400"}}>
              <li>You have the right to request a copy of your personal information to verify accuracy
              and/or correct or update the data;</li>
              <li>You can opt out of receiving emails at any time by sending a notice to
              info@noraspora.lv;</li>
              <li>If your data is processed with your consent, you have the right to withdraw your consent
              at any time, which will stop further processing;</li>
              <li>You have the right to receive confirmation of data processing, review processed data,
              obtain information on processing purposes, processing period, data sources, significance,
              and consequences for you;</li>
              <li>You can request that your personal information be fully deleted (if not contrary to Latvian
              law).</li>
            </ul>
            <p>
              To protect your privacy and security, we will take appropriate measures to verify your identity
              before providing the requested personal data. We may ask you to provide an identity document
              and/or visit our workshop in person. If you cannot prove your identity, we may reject your
              request.
            </p>
            <p>
              We will use commercially reasonable efforts to notify you within 30 days of a request if access is
              denied and explain the reasons if applicable.
            </p>
            <p>
              You have the right to object to our processing of your personal data if we are doing so legally or
              based on our legitimate interests. Your objections are considered and processed in accordance
              with applicable laws.
            </p>
          </li>

          <li>YOUR RIGHT TO SUPPORT
            <p>
              If you have questions about this privacy policy or your data usage, please contact us at
              info@noraspora.lv.
            </p>
            <p>
              Each new version of the privacy policy will appear on this page. The last changes came
              into effect on May 24, 2018.
            </p>
          </li>
          <li>CHANGES TO THE POLICY
            <p>
              We regularly review our privacy policy. All changes will be published on this page. This
              privacy policy came into effect and was last updated on June 20, 2024.
            </p>
          </li>

          </ol>
      </div>
    )
  }

  // --- Default Latvian Version ---
  // If lang is not 'en' (or is null/undefined), display the original Latvian
  return (
    <div className="noteikumi privatuma">
      <Helmet>
        <title>Nora Spora - Privātuma politika</title>
        <meta name="description" content="Izpētiet mūsu privātuma politiku lai uzzinātu kā mēs aizsargājam Jūsu personas datus un nodrošinām to drošību." />
        <meta name="keywords" content="privātuma politika, datu aizsardzība, personas dati, NORA SPORA" />
        <meta name="robots" content="index, follow" />
      </Helmet>
        <h2 className="light">Privātuma politika</h2>
        <ol>
            <li>VISPĀRĪGIE NOTEIKUMI
                <p>
                Šī "Konfidencialitātes politika" (turpmāk "Politika") attiecas uz visiem uzņēmuma SIA "NORA SPORA"(turpmāk "Mēs", "Mums", "Mūs") "Vietnes" (turpmāk "Vietne") "Lietotājiem" (tālāk tekstā - "Jūs", "Jums", "Jūsu").Pirms pasūtījuma veikšanas uzmanīgi izlasiet Politiku. Laika gaitā mēs varam ieviest izmaiņas politikā, lūdzu, pārlasiet to pirms atkārtotas pirkumu veikšanas.
                <br /><br />
                Saskaņā ar vispārējiem datu aizsardzības noteikumiem personas dati ir jebkāda informācija, ko var izmantot, lai identificētu personu, kā arī jebkāda informācija par personu, kura jau ir identificēta. Izmantojot mūsu vietnes pakalpojumus, Jūs sniedzat mums savus personas datus, tiesības apstrādāt un izmantot tos saskaņā ar noteikumiem, kas izklāstīti Konfidencialitātes politikā un "Lietošanas noteikumos" (turpmāk "Noteikumi").
                <br /><br />
                Mēs apņemamies aizsargāt mūsu klientu un vietnes apeklētāju, tostarp Jūsu, privātumu un drošību.Izmantojot mūsu vietnes pakalpojumus Jūs izrādat mums uzticēšanos. Mēs to pilnībā novērtējam un cienām Jūsu datu privātuma un konfidecialitātes nozīmīgumu.Mēs ievērojam personas datu minimizēšanas principu – mēs nepieprasām, neapkopojam un neapstrādājam personas datus, kas nav nepieciešami, lai sasniegut mērķi – iegādāties preces, pakalpojumus vai saņemt informāciju.Mēs cienām Jūsu privātumu un daram visu iespējamo lai uzglabātu Jūsu personas datus drošībā.Mēs nepieļaujam nevēlamu vēstuļu nosūtīšanu un nekādā gadījumā nepieļausim jebkādu Jūsu personīgo datu (vārds, adrese, e-pasta adrese utt.) pārdošanu, iznomāšanu vai nodošanu trešajām personām.Informāciju trešājām personām var izpaust tikai, pamatojoties uz likumīga pieprasījuma, līguma vai ar Jūsu piekrišanas saņemšanu.
                <br /><br />
                Jūs esat atbildīgs par informācijas patiesumu, veicot pasūtījumu vai sazinoties ar klientu atbalsta dienestu. Jūs apliecināt, ka Jūs neesat jaunāks par 16 gadiem, kā arī apņematies neveikt nekādas darbības, kas vērstas pret vietnes drošību.Mēs neesam atbildīgi par nepareiziem, nepilnīgiem vai kļūdainiem Jūsu sniegtajiem datiem.Izmantojot mūsu tīmekļa vietni un / vai iegādājoties preces un / vai pakalpojumus, Jūs apliecināt, ka Jūs saprotat politiku, un Jūs piekrītat sekot izmaiņām tajā.
                <br /><br />
                Ja Jūs nepiekrītat šai politikai vai atsevišķām tajā ietvertām definīcijām, lūdzu, neizmantojiet mūsu vietnes pakalpojumus.
                </p>
            </li>

            <li>KĀDUS DATUS MĒS APKOPOJAM UN APSTRĀDĀJAM?
              <p>
                Veicot pirkumu vai sazinoties ar klientu atbalsta dienestu, Jūs sniedzat mums savu personīgo informāciju. Veicot pirkumu, personas datu iesniegšana ir obligāta, jo bez tā Jūs nevarēsiet pirkumu veikt.
                <br /><br />
                Mēs apkopojam un uzglabājam šādus datus:
              </p>
              <ul className="" style={{listStyle: "disc", paddingLeft: "20px", fontWeight: "400"}}>
                <li>klienta vārds un uzvārds;</li>
                <li>tālruņa numurs;</li>
                <li>e-pasta adrese;</li>
                <li>preču vai pakalpojumu piegādes adrese.</li>
              </ul>
              <p>
                <br />
                Privāto informāciju izmanto tikai, lai nodrošinātu pilnvērtīgu pakalpojumu sniegšanu un saziņai ar klientiem.
                <br /><br />
                Mēs varam saņemt Jūsu personīgo informāciju tikai no Jums un tikai tad, ja Jūs izmantojat mūsu vietnes pakalojumus, piemēram: pasūtījumu reģistrāciju, sazinaties ar klientu atbalstu, izmantojot atsauksmju veidlapu vai e-pastu.
              </p>
            </li>

            <li>MAKSĀJUMA INFORMĀCIJA
          <p>
          Maksājumu apstrādi nodrošina maksājumu platforma <a href="https://makecommerce.lv">makecommerce.lv</a>, tāpēc mūsu uzņēmums maksājumu izpildei nepieciešamos personas datus nodod platformas īpašniekam Maksekeskus AS.
          </p>
          <p>
            Maksājot par precēm un pakalpojumiem, ko sniedz SIA "NORA SPORA" vietne, mēs varam apkopot un apstrādāt šādu informāciju:
          </p>
          <ul style={{listStyle: "disc", paddingLeft: "20px", fontWeight: "400"}}>
            <li>Jūsu bankas konta numurs;</li>
            <li>bankas iestādes nosaukums;</li>
            <li>Jūsu tālruņa numurs;</li>
            <li>e-pasta adrese.</li>
          </ul>
          <p>
            Informāciju par Jūsu bankas norēķinu karti mēs nesaņemam un tā netiek apstrādāta.
          </p>
        </li>

        <li>KĀDEĻ MĒS APKOPOJAM JŪSU DATUS
          <p>
            Mēs izmantojam informāciju, ko apkopojam par Jums, lai:
          </p>
          <ul style={{listStyle: "disc", paddingLeft: "20px", fontWeight: "400"}}>
            <li>pārdodu mūsu preces un pakalpojumus;</li>
            <li>pareizi apstrādātu un piegādātu Jūsu pasūtījumu;</li>
            <li>nodrošinātu garantijas un pēcgarantijas atbalstu;</li>
            <li>atbildētu uz Jūsu jautājumiem un sniegtu Jums informāciju;</li>
            <li>sagatavotu anonīmu statistiku par vietnes izmantošanu.</li>
          </ul>
        </li>

        <li>CIK ILGI MĒS UZGLABĀJAM JŪSU DATUS
          <p>
            Klienta personisko informāciju mēs glabājam 10 gadus:
          </p>
          <ul style={{listStyle: "disc", paddingLeft: "20px", fontWeight: "400"}}>
            <li>lai nodrošinātu iegādāto preci ar garantijas un pēcgarantijas atbalstu;</li>
            <li>lai sazinātos ar Jums par pieprasījumu;</li>
            <li>grāmatvedībai.</li>
          </ul>
          <p>
            Pēc 10 gadu termiņa beigām, personas dati tiks iznīcināti, ja Jūs nepieprasīsit savu datu dzēšanu šajā periodā.
          </p>
        </li>

        <li>DATU NODOŠANA TREŠĀJĀM PERSONĀM
          <p>
            Jūsu dati var tikt nodoti trešajai personai, kas var būt - datu centri, atbalsta pakalpojumi, piegādes pakalpojumi, mākoņu glabāšanas pakalpojumu pārstāvji utt. Personīgo datu apstrādātāji, kas palīdz mums sniegt Jums pakalpojumus. Jebkurā gadījumā apstrādātājiem tiek nodots tikai tāds datu apjoms, kas nepieciešams konkrēta uzdevuma izpildei vai konkrēta pakalpojuma sniegšanai. Ar mums saistītās trešās personas var apstrādāt Jūsu personas datus tikai noteiktajiem uzdevumiem un tos nevar izmantot citiem mērķiem vai nodot citām personām bez mūsu piekrišanas. Apstrādātāji nodrošina Jūsu personas datu aizsardzību saskaņā ar spēkā esošajiem normatīvajiem aktiem.
          </p>
          <p>
            Personas dati var tikt nodoti kompetentajām valsts varas un pārvaldes iestādēm, tostarp tiesībsargājošajām iestādēm, piemēram, policijai vai citām uzraudzības iestādēm, bet tikai nepieciešamības gadījumā un saskaņā ar normatīvajos aktos noteikto tiesisko kārtību.
          </p>
        </li>

        <li>DATU NODOŠANA TREŠĀM VALSTĪM
          <p>
            SIA "NORA SPORA" nenodod personīgo informāciju un citus datus trešām valstīm.
          </p>
          <p>
            Personīgo un citu lietotāju datu izsniegšana tiek veikta tikai, pamatojoties uz likumīgu pieprasījumu.
          </p>
        </li>

        <li>LIETOTĀJA TIESĪBAS
          <p>
            Normatīvie akti par personas datu aizsardzību, tai skaitā Vispārīgā datu aizsardzības regula dod Jums virkni tiesību, savukārt, mums jānodrošina Jums iespēju tās izmantot.
          </p>
          <ul style={{listStyle: "disc", paddingLeft: "20px", fontWeight: "400"}}>
            <li>Jums ir tiesības pieprasīt Jūsu personiskās informācijas kopiju, lai pārbaudītu uzglabātās informācijas precizitāti un / vai labotu vai atjauninātu šos datus;</li>
            <li>jebkurā laikā Jūs varat atteikties saņemt e-pastus, nosūtot paziņojumu uz info@noraspora.lv;</li>
            <li>gadījumos, kad Jūsu dati tiek apstrādāti ar Jūsu piekrišanu, Jums ir tiesības jebkurā brīdī atsaukt savu piekrišanu, kas kalpo par pamatu datu apstrādes izbeigšanai;</li>
            <li>Jums ir tiesības saņemt Jūsu datu apstrādes apstiprinājumu, tiesības pārskatīt apstrādātos datus, iegūt informāciju par apstrādes mērķiem, apstrādes periodu, datu saņemšanas avotiem, to nozīmi un Jums no tā izrietošajām sekām;</li>
            <li>Jūs varat pieprasīt, lai Jūsu personiskā informācija tiktu pilnībā izdzēsta (ja tas nav pretrunā ar Latvijas Republikas likumdošanu).</li>
          </ul>
          <p>
            Lai aizsargātu Jūsu konfidencialitāti un drošību, mēs veiksim atbilstošus pasākumus, lai pārbaudītu Jūsu identitāti, pirms sniegt Jūsu pieprasīto informāciju par saviem personīgajiem datiem. Šim nolūkam mēs varam lūgt Jūs iesniegt personu apliecinošu dokumentu un / vai personīgi apmeklēt mūsu darbnīcu. Ja Jūs nevarat pierādīt savu identitāti, mēs varam noraidīt Jūsu pieteikumu.
          </p>
          <p>
            Mēs izmantosim visus komerciāli saprātīgos centienus, lai 30 dienu laikā pēc Jūsu piekļuves pieprasījuma izpildīšanas paziņotu Jums par piekļuves atteikuma iemesliem, ja tas ir attiecināms.
          </p>
          <p>
            Jums ir tiesības iebilst pret mums, apstrādājot Jūsu personas datus, ja mēs to darām likumīgi vai pamatojamies uz mūsu legitīmo interešu apstrādi. Jūsu iebildumi tiek apsvērti un apstrādāti saskaņā ar spēkā esošajiem tiesību aktiem.
          </p>
        </li>

        <li>JŪSU TIESĪBAS IZMANTOT ATBALSTU
          <p>
            Ja Jums ir jautājumi par šo privātuma politiku, kā arī par Jūsu datu izmantošanu, lūdzu, sazinieties ar mums info@noraspora.lv
          </p>
          <p>
            Katra jauna privātuma politikas versija, kas tiek izveidota, parādīsies šajā lapā. Pēdējās izmaiņas stājās spēkā 2018. gada 24. maijā.
          </p>
        </li>
        <li>IZMAIŅAS POLITIKĀ
          <p>
            Mēs regulāri pārskatām mūsu konfidencialitātes politiku. Visas izmaiņas tiks publicētas šajā lapā.
            Šī konfidencialitātes politika stājās spēkā un pēdējoreiz tika atjaunināta 2024. gada 20. jūnijā.
          </p>
        </li>

        </ol>
    </div>
  )
}

export default PrivatumaPolitika